<template>

  <div class="home">
    <header></header>
    <img alt="Vue logo" src="../assets/logo.png">
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";

export default {
  name: 'home',
  components: {
    Header
  }
}
</script>
